module.exports = __webpack_public_path__ + "img/002-devil.2ca6d9d7.png";